import CompositeModel from './composite-model';

export default CompositeModel;
